import {useQuery} from '@tanstack/react-query';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {apiClient} from '@common/http/query-client';
import { LoanProgram } from '../loan-program';

const Endpoint = (loan_product_id: number) => `loan-products/${loan_product_id}/loan-programs`;

export interface FetchLoanProgramResponse extends BackendResponse {
   loan_programs: LoanProgram[];
}

export function useLoanPrograms(loan_product_id: number) {
  return useQuery({
    queryKey: [Endpoint( loan_product_id )],
    queryFn: () => fetchLoanProgram( loan_product_id ),
  });
}

function fetchLoanProgram( loan_product_id: number): Promise<FetchLoanProgramResponse> {
  return apiClient.get(Endpoint(loan_product_id)).then(response => response.data);
}
